module.exports = __webpack_public_path__ + "img/julien-vincent.dedf22f7.jpg";